export const DEFAULT_HEADING = 'Калькулятор займов';
export const DEFAULT_SUB_HEADING =
  'Укажите параметры займа и сравните предложения по размеру ежемесячного платежа, сумме переплаты и процентной ставке';
